import HttpCodes from 'configs/HttpCodes';
import Settings from 'configs/Settings';

const ENTITY_TYPE = {
  // video and audio upload on page content form
  PAGE_MEDIA: 'PAGE_MEDIA',

  // video and audio upload on page content form
  PAGE_ATTACHMENT: 'PAGE_ATTACHMENT',

  // module purchase tab group
  MODULE_PURCHASE_DATA: 'MODULE_PURCHASE_DATA',

  // sales purchase tab group
  MEMBERSHIP_PURCHASE_DATA: 'MEMBERSHIP_PURCHASE_DATA',

  MEMBERSHIP_LOGO: 'MEMBERSHIP_HEADER_IMG',

  MEMBERSHIP_BACKGROUND: 'MEMBERSHIP_BACKGROUND_IMG',

  MEMBERSHIP_PRESENTATION: 'MEMBERSHIP_LOGO_IMG',

  MEMBERSHIP_BACKGRD_AUDIO_VIDEO: 'MEMBERSHIP_BACKGRD_AUDIO_VIDEO',

  CERTIFICATE_IMG: 'CERTIFICATE_IMG',

  CERTIFICATE_BACKGROUND_IMG: 'CERTIFICATE_BACKGROUND_IMG',

  // advertisement tab group
  RECOMMENDATION: 'RECOMMENDATION',

  // midnight's page thumbnail/background
  PAGE_BACKGROUND_IMG: 'PAGE_BACKGROUND_IMG',

  // redactor's image uploader
  PAGE_CONTENT_IMG: 'PAGE_CONTENT_IMG',

  // profile image upload inside the quiz
  QUIZ_PROFILE_IMG: 'QUIZ_PROFILE_IMG',

  // user profile image
  USER_PROFILE_IMG: 'USER_PROFILE_IMG',

  // persona profile IMAGE
  PERSONA_IMG: 'PERSONA_IMG',

  LIVE_THUMBNAIL: 'LIVE-THUMBNAIL',

  TRACK_IMG: 'TRACK_IMG',

  MODULE_COVER_IMG: 'MODULE_COVER_IMG'
};

const ENTITY_DATA_TYPE = {
  MEDIA: 'MEDIA',
  IMAGE: 'IMG'
};

const FILE_PLAYER_EXTENSIONS = [
  // mp4
  'audio/mp4',
  'video/mp4',
  'application/mp4',

  // mov
  'video/quicktime',
  'video/x-quicktime',
  'image/mov',
  'audio/aiff',
  'audio/x-midi',
  'audio/x-wav',

  // mkv
  'video/x-matroska',

  // avi
  'video/avi',
  'video/msvideo',
  'video/x-msvideo',
  'image/avi',
  'video/xmpg2',
  'application/x-troff-msvideo',
  'audio/aiff',
  'audio/avi',

  // mp3
  'audio/mpeg',
  'audio/x-mpeg',
  'audio/mp3',
  'audio/x-mp3',
  'audio/mpeg3',
  'audio/x-mpeg3',
  'audio/mpg',
  'audio/x-mpg',
  'audio/x-mpegaudio'
];

const FILE_IMAGE_EXTENSIONS = [
  // jpg
  'image/jpeg',
  'image/jpg',
  'image/jp_',
  'application/jpg',
  'application/x-jpg',
  'image/pjpeg',
  'image/pipeg',
  'image/vnd.swiftview-jpeg',
  'image/x-xbitmap',

  // png
  'image/png',
  'application/png',
  'application/x-png'
];

const FILE_TYPE = {
  AUDIO: 'AUDIO',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
};

const FILE_EXCEPTIONS = {
  BIG_FILE: 'big_file',
  INVALID_EXTENSION: 'invalid_file',
  FILES_LIMIT: 'files_limit'
};

const CONFIG_URL = `${Settings.api.fileClub}/v4/upload/config`;

const FILES_URL = `${Settings.api.fileClub}/public/v5/files`;

const MAX_THUMBNAIL_SIZE = 2e6;

const MAX_PAGE_BACKGROUND_SIZE = 2e6;

const MAX_QUIZ_PROFILE_IMG_SIZE = 2097152;

const MAX_MEMBERSHIP_LOGO_SIZE = 102400;

const MAX_MEMBERSHIP_BACKGROUND_SIZE = 102400;

const MAX_MEMBERSHIP_PRESENTATION_SIZE = 102400;

const MAX_MEMBERSHIP_BACKGRD_AUDIO_VIDEO_SIZE = 102400;

const UPLOAD_STATUS = {
  STARTED: 'UPLOAD_STARTED',
  FAILED: 'FAILED',
  FINISHED: 'UPLOAD_FINISHED'
};

const ASYNC_IMAGE_INTERVAL = 3000;
const RETRY_GET_THUMBNAIL_INTERVAL = 15000;
const ASYNC_IMAGE_MAX_TRIALS = 5;
const VALID_FILE_REQUEST_STATUS = [HttpCodes.OK, HttpCodes.FOUND];

const DEFAULT_PROFILE_IMAGE_SIZE = {
  height: 130,
  width: 130
};
const DEFAULT_PROFILE_THUMBNAIL_SIZE = {
  height: 50,
  width: 50
};

const FILES_SYSTEM = 'club_admin';

const THUMBNAIL_ALLOWED_EXTENSIONS = ['image/png', 'image/jpg', 'image/jpeg'];

const DRM_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  IN_PROGRESS: 'IN_PROGRESS'
};

const FILE_ATTACHMENT_FORMATS = [
  'jpg',
  'gif',
  'png',
  'bmp',
  'pdf',
  'zip',
  'rar',
  'epub',
  'xls',
  'xlsx',
  'xlsm',
  'mp3',
  'doc',
  'docx',
  'ppt',
  'pptx'
];

export {
  ASYNC_IMAGE_INTERVAL,
  ASYNC_IMAGE_MAX_TRIALS,
  DEFAULT_PROFILE_IMAGE_SIZE,
  DEFAULT_PROFILE_THUMBNAIL_SIZE,
  CONFIG_URL,
  ENTITY_DATA_TYPE,
  ENTITY_TYPE,
  FILES_SYSTEM,
  FILES_URL,
  FILE_EXCEPTIONS,
  FILE_IMAGE_EXTENSIONS,
  FILE_PLAYER_EXTENSIONS,
  FILE_TYPE,
  MAX_MEMBERSHIP_BACKGRD_AUDIO_VIDEO_SIZE,
  MAX_MEMBERSHIP_BACKGROUND_SIZE,
  MAX_MEMBERSHIP_LOGO_SIZE,
  MAX_MEMBERSHIP_PRESENTATION_SIZE,
  MAX_PAGE_BACKGROUND_SIZE,
  MAX_QUIZ_PROFILE_IMG_SIZE,
  MAX_THUMBNAIL_SIZE,
  UPLOAD_STATUS,
  VALID_FILE_REQUEST_STATUS,
  THUMBNAIL_ALLOWED_EXTENSIONS,
  DRM_STATUS,
  FILE_ATTACHMENT_FORMATS,
  RETRY_GET_THUMBNAIL_INTERVAL
};
